import { ADMIN_PAGE_URL, HOME_PAGE_URL } from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  ...(user?.email
    ? [
        ...(user.role === 'ADMIN' || user.role === 'DEVELOPER'
          ? [{ path: ADMIN_PAGE_URL, label: 'Admin' }]
          : []),
      ]
    : []),
];